/* eslint-disable max-len */

const GreyPlus: React.FC = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.66667 5.66659H5.66667V9.66659H4.33334V5.66659H0.333336V4.33325H4.33334V0.333252H5.66667V4.33325H9.66667V5.66659Z" fill="#868E96" />
  </svg>
);

export default GreyPlus;
